var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field-wrapper field-wrapper--select",
      class: [
        _vm.field.cssClass,
        { "visually-hidden": _vm.field.visibility === "hidden" },
        "field-wrapper--" + _vm.field.size
      ]
    },
    [
      _c(
        "div",
        {
          staticClass: "field-group field-group--select",
          class: [{ "field-group--is-error": _vm.isError }]
        },
        [
          _c(
            "label",
            {
              staticClass: "label label--select",
              class: [
                {
                  "visually-hidden": _vm.field.labelPlacement === "hidden_label"
                }
              ],
              attrs: { for: "input_" + _vm.formId + "_" + _vm.field.id }
            },
            [
              _vm._v("\n      " + _vm._s(_vm.field.label)),
              _vm.field.isRequired ? _c("sup", [_vm._v("*")]) : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.isMobileAndTouch
            ? [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedValue,
                        expression: "selectedValue"
                      }
                    ],
                    staticClass: "select select--big",
                    class: [
                      {
                        "select--locations": _vm.field.adminLabel === "Standort"
                      }
                    ],
                    attrs: {
                      id: "input_" + _vm.formId + "_" + _vm.field.id,
                      name: "input_" + _vm.field.id,
                      required: _vm.field.isRequired
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedValue = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.filteredChoices, function(choice) {
                    return _c(
                      "option",
                      { domProps: { value: choice.value || choice.slug } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(choice.text || choice.name) +
                            "\n        "
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            : [
                _vm.field.adminLabel === "Standort"
                  ? [
                      _vm.filteredChoices && _vm.filteredChoices.length > 0
                        ? _c(
                            "multiselect",
                            {
                              staticClass: "multiselect--locations",
                              attrs: {
                                id: "input_" + _vm.formId + "_" + _vm.field.id,
                                options: _vm.results,
                                "custom-label": _vm.completeAddress,
                                placeholder:
                                  _vm.$store.state.lexicon
                                    .location_or_postal_code,
                                "internal-search": false,
                                loading: _vm.isLoading,
                                "track-by": "value"
                              },
                              on: { "search-change": _vm.asyncFind },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "option",
                                    fn: function(props) {
                                      return [
                                        props.option &&
                                        props.option.description &&
                                        props.option.description
                                          .address_postal_code
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "multiselect__option-text"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (props.option.description
                                                      .address_postal_code
                                                      ? "CH-" +
                                                        props.option.description
                                                          .address_postal_code
                                                      : "") +
                                                      " " +
                                                      props.option.description
                                                        .address_city +
                                                      (props.option.description
                                                        .address_street
                                                        ? ", " +
                                                          props.option
                                                            .description
                                                            .address_street
                                                        : "")
                                                  )
                                                )
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "multiselect__option-text multiselect__option-text--no-icon"
                                              },
                                              [_vm._v("-")]
                                            )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                955351653
                              ),
                              model: {
                                value: _vm.selectedObject,
                                callback: function($$v) {
                                  _vm.selectedObject = $$v
                                },
                                expression: "selectedObject"
                              }
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  attrs: { slot: "noResult" },
                                  slot: "noResult"
                                },
                                [_vm._v(_vm._s(_vm.lexicon.location_no_result))]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  : [
                      _vm.filteredChoices && _vm.filteredChoices.length > 0
                        ? _c("multiselect", {
                            staticClass: "multiselect--regular",
                            attrs: {
                              id: "input_" + _vm.formId + "_" + _vm.field.id,
                              options: _vm.results,
                              label: "text",
                              placeholder: "-",
                              "track-by": "value"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "singleLabel",
                                  fn: function(ref) {
                                    var option = ref.option
                                    return [_vm._v(_vm._s(option.text))]
                                  }
                                }
                              ],
                              null,
                              false,
                              3831414869
                            ),
                            model: {
                              value: _vm.selectedObject,
                              callback: function($$v) {
                                _vm.selectedObject = $$v
                              },
                              expression: "selectedObject"
                            }
                          })
                        : _vm._e()
                    ]
              ]
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("description"),
      _vm._v(" "),
      _vm._t("error")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }